
export const FORMSPREE_KEYS = {
  contact: "xvzezvry",
  hireTalent: "xreneokw",
  managedService: "mbdndpyn",
  corporateTraining: "mjgngpov",
  startProject: "xpqvqork",
  becomePartner: "mojgjpwk",
  individualTraining: "xeeyepkl", // TODO: replace with the real Formspree form ID
};

export const formspreeUrl = (key: string) =>
  `https://formspree.io/f/${key}`;
